import { useT } from '../i18n'
import { useNewVersionAvailable } from '../offline/appShell/newVersion'

// Findings #146: "Hay una nueva versión — toca para actualizar". Shown on the
// crew phone and in the office app when a newer version is deployed than the
// one this tab is running; the tap reloads the page (unsent records stay in
// the device's storage and keep syncing).
export default function NewVersionBanner({ compact = false }: { compact?: boolean }) {
  const t = useT()
  const available = useNewVersionAvailable()
  if (!available) return null
  return (
    <button
      type="button"
      data-testid="new-version-banner"
      onClick={() => window.location.reload()}
      style={{
        display: 'block',
        width: compact ? 'calc(100% - 24px)' : '100%',
        margin: compact ? '8px 12px 0' : '8px 0 0',
        padding: '10px 12px',
        borderRadius: 10,
        border: '1px solid #93c5fd',
        background: '#eff6ff',
        color: '#1e3a8a',
        fontWeight: 700,
        fontSize: 14,
        textAlign: 'left',
        cursor: 'pointer'
      }}
    >
      {t('app.newVersion.banner')}
    </button>
  )
}
